<ng-template #content>
  <app-orders-grid
    #grid
    (filterChange)="onFilterChange($event)"
    (filterClickChange)="onFilterClickChange($event)"
    [datesearch]="true"
    [textsearch]="false"
    [startdate]="startDate"
    [enddate]="endDate"
  ></app-orders-grid>
</ng-template>
<ng-template #docname>
  <app-input
    label="Dokumentname"
    [(value)]="fileName"
    suffix=".pdf"
    [placeholder]="placeholder"
  ></app-input>
</ng-template>
<ng-template #sorting>
  <mat-form-field style="width: 100%" floatLabel="always">
    <mat-label>Sortierung</mat-label>
    <mat-select [formControl]="sortFC" [compareWith]="selectById">
      <mat-option *ngFor="let t of sortTypes" [value]="t">
        <span *ngIf="t.dir === 'asc'">&uarr;</span>
        <span *ngIf="t.dir === 'desc'">&darr;</span>
        {{ t.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-template>

<ng-template #tools>
  <div
    class="row-layout flex-content-space-between"
    style="flex: 1; margin-right: 1rem; align-items: center;"
  >
    <div style="width: 16rem; margin-right: 1rem">
      <ng-container *ngTemplateOutlet="sorting"></ng-container>
    </div>
    <div>
      <a *ngIf="downloadLink" [href]="downloadLink" target="_blank">Download</a>
    </div>
  </div>
  <div [ngClass]="btnClass">
    <button mat-button (click)="close()">Abbrechen</button>
    <button mat-button style="margin-left: 1rem" (click)="save()">
      Erzeugen
    </button>
  </div>
</ng-template>
<ng-container *ngIf="isDialog">
  <h2 mat-dialog-title style="text-align: center">{{title}}
  </h2>
  <mat-dialog-content class="mat-typography">
    <div
      style="
        min-height: 50vh;
        max-height: 70vh;
        overflow: auto;
        padding: 8px;
        border: 1px solid grey;
        border-radius: 4px;
        margin-top: 8px;
        display: flex;
      "
    >
      <div style="flex: 1">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
    </div>
    <div class="row-layout" style="justify-content: stretch; margin-top: 16px">
      <div style="flex: 1">
        <ng-container *ngTemplateOutlet="docname"></ng-container>
      </div>
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions class="row-layout flex-content-space-between">
    <ng-container *ngTemplateOutlet="tools"></ng-container>
  </div>
</ng-container>

<ng-container *ngIf="!isDialog">
  <div *ngIf="isAdmin" class="row-layout" style="width: 100%; height: 100%">
    <div style="flex: 1; height: 100%">
      <div
        class="row-layout flex-layout-space-between"
        style="flex: 1; padding-left: 1rem; margin-top: 4px"
      >
        <div style="flex: 1">
          <div style="max-width: 20rem; margin-right: 1rem">
            <ng-container *ngTemplateOutlet="sorting"></ng-container>
          </div>
        </div>
        <div class="row-layout" style="padding-left: 1rem">
          <div
            class="row-layout"
            style="align-items: center; margin-right: 24px"
          >
            <div style="margin-right: 16px">Von:</div>
            <app-date-picker
              [no-hint]="true"
              [value]="startDate"
              (valueChange)="onStartDateChange($event)"
            ></app-date-picker>
          </div>
          <div
            class="row-layout"
            style="align-items: center; margin-right: 24px"
          >
            <div style="margin-right: 16px">Bis:</div>
            <app-date-picker
              [no-hint]="true"
              [value]="endDate"
              (valueChange)="onEndDateChange($event)"
            ></app-date-picker>
          </div>
          <div style="padding-top: 8px">
            <button
              mat-button
              (click)="search()"
              class="light-bg-color"
              style="height: 40px"
            >
              Suche starten
            </button>
          </div>
        </div>
      </div>
      <div
        class="row-layout flex-content-space-between"
        style="padding: 0 0 0 1rem; margin-top: 4px"
      >
        <div
          class="row-layout flex-content-space-between"
          style="flex: 1; margin-right: 1rem; align-items: center"
        >
          <div style="width: 100%">
            <ng-container *ngTemplateOutlet="docname"></ng-container>
          </div>
        </div>
        <div
          class="row-layout flex-content-end"
          style="margin-left: 1rem; align-items: center"
        >
          <div>
            <a *ngIf="downloadLink" [href]="downloadLink" target="_blank"
              >Download</a
            >
          </div>
          <button
            mat-button
            class="light-bg-color"
            style="margin-left: 1rem; height: 40px"
            (click)="save()"
          >
            Erzeugen
          </button>
        </div>
      </div>
      <div
        class="column-layout"
        style="height: 100%; padding: 16px"
        #docwrapper
      >
        <div #doctable style="flex: 1; overflow: auto">
          <table class="orders-documents-table">
            <thead
              class="bg-white pos-relative"
              style="top: 0; left: 0; z-index: 1000"
            >
              <tr>
                <th class="cb-column" style="background-color: white">
                  <mat-checkbox
                    [checked]="allSelected"
                    (change)="selectAllDocuments($event)"
                  ></mat-checkbox>
                </th>
                <th>Auftrag</th>
                <th>Datum</th>
                <th>Kunde</th>
                <th>Partner</th>
                <th>Aktionen</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of files; let $idx = index">
                <tr
                  [id]="'doc_row_' + item.id"
                  style="height: 48px"
                  [ngClass]="{
                    'table-grey-bg': $idx % 2 === 0
                  }"
                >
                  <td class="cb-column">
                    <mat-checkbox
                      [checked]="item.selected"
                      (change)="selectDocument($event, item)"
                    ></mat-checkbox>
                  </td>
                  <td>{{ item.id }}</td>
                  <td>{{ item.work_day }}</td>
                  <td>{{ item.cname }}</td>
                  <td>{{ item.pname }}</td>
                  <td>
                    <div class="row-layout" style="align-items: center">
                      <app-download-document
                        [data]="item"
                      ></app-download-document>
                      <div
                        *ngIf="item.canview"
                        class="montage-docs-action-separator"
                      ></div>
                      <app-view-document
                        *ngIf="item.canview"
                        [data]="item"
                        (action)="onViewClick($event)"
                      ></app-view-document>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
        <div #docbuttons style="height: 1rem; width: 100%"></div>
      </div>
      <!--
    <div class="edit-orders-header row-layout flex-content-space-between">
      <ng-container *ngTemplateOutlet="tools"></ng-container>
    </div>
    --></div>
    <div style="width: 1rem"></div>
  </div>
</ng-container>

<!--
                        <button
                          mat-icon-button
                          (click)="toggleDocumentVisibility(item)"
                          style="border: 1px solid grey; width: 40px"
                        >
                          <mat-icon
                            *ngIf="item.montage_visible"
                            style="margin-top: -4px"
                            >visibility_off</mat-icon
                          >
                          <mat-icon
                            *ngIf="!item.montage_visible"
                            style="margin-top: -4px"
                            >visibility</mat-icon
                          >
                        </button>
                      -->
